import React, { useEffect, useRef, useContext } from 'react';
import './Awaken.scss';
import TimelineText from '@/v2/components/atoms/TimelineText';
import VideoSimple from '@/v2/components/media/video/VideoSimple';
import Header from '@/v2/components/application/Header';
import Disclaimer from '@/v2/components/layouts/Disclaimer';
import { DesignContext } from '@/v2/state/providers';
import { MomentStateContext } from '@/v2/state/momentState';
import { timeout, clearTimeouts } from '@/v2/components/utils/Timeout';

let videoController = null;

const videoReady = (controller, onReady, setTime) => {
    videoController = controller;
    videoController.AddOnTimeUpdated(() => {
        setTime(videoController.GetTime());
    });

    onReady();
};

const play = () => {
    videoController.Play();
};

const activate = () => {};

export default ({ isActive, data, onFinished, onReady }) => {
    const [{ disclaimer }] = useContext(DesignContext);
    const { dispatch: momentDispatch } = useContext(MomentStateContext);

    const time = useRef(TimelineText.Time());

    const videoFinished = () => {
        // delaying execution till video playback finishes
        timeout(onFinished, 800);
    };

    if (isActive) {
        activate();
    }

    useEffect(() => () => clearTimeouts(), []);

    useEffect(() => {
        if (isActive && videoController) {
            videoController.ProgressDispatch(momentDispatch);
        }
    }, [isActive, videoController]);

    const options = {
        bufferBeforePlay: true,
        onReady: (controller) => {
            videoReady(controller, onReady, time.current.Set);
            play();
        },
        autoPlay: false,
        onFinished: () => videoFinished(onFinished),
    };

    const headerContent = <Header show={isActive} animate hideLogo />;
    const disclaimerContent = isActive && disclaimer ? <Disclaimer data={disclaimer} /> : '';

    return (
        <div className="Awaken">
            <VideoSimple src={data.video} options={options} />
            {headerContent}
            {isActive && (
                <>
                    <div className="Awaken__slider-container">{disclaimerContent}</div>
                    <TimelineText data={data.text.timeline} time={time.current} />
                </>
            )}
        </div>
    );
};
